export default "__VITE_ASSET__DQSz6Eu7__"